var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('router-link',{attrs:{"to":{name: 'user.view', params: {id: _vm.id}}},domProps:{"textContent":_vm._s(_vm.userName || _vm.id)}}):_c('span',[_vm._v(" "+_vm._s(_vm.userName || _vm.id)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }